import React, { useState, useEffect } from 'react';
import HelpTogal from '../TogelButton/HelpTogal';
import ExpensesServices from '../../services/ExpensesServices.js';

function UpdateCoupan({ data, closeModal, onSuccess }) {

  const [formValues, setFormValues] = useState({
    expensesName: '',
    serialNumber: '',
    amount: '',
    image: '',
    date: '',
    paymentMethod: 'offline',
    transactionId: '',
    bankName: '',
    accountNumber: '',
    upiId: '',
    chequeNumber: '',
  });

  const [previewImage, setPreviewImage] = useState('img/placeholder-img.png');

  useEffect(() => {
    if (data) {
      console.log("Received data:", data);

      const formattedDate = data?.date
        ? new Date(data.date).toISOString().split('T')[0]
        : '';

      setFormValues({
        expensesName: data?.expensesName || '',
        serialNumber: data?.serialNumber || '',
        amount: data?.amount || '',
        image: data?.image || '',
        date: formattedDate,
        paymentMethod: data?.paymentMethod || 'offline',
        transactionId: data?.transactionId || '',
        bankName: data?.bankName || '',
        accountNumber: data?.accountNumber || '',
        upiId: data?.upiId || '',
        chequeNumber: data?.chequeNumber || '',
      });
      if (data.image) {
        setPreviewImage(process.env.REACT_APP_URL + data.image);
      }
    }
  }, [data]);


  const handleInputChange = (event) => {
    const { name, value } = event.target;
    if (name === 'paymentMethod') {
      setFormValues({
        ...formValues,
        [name]: value,
        ...(value === 'online'
          ? { chequeNumber: '' }
          : { transactionId: '', bankName: '', accountNumber: '', upiId: '' }
        )
      });
    } else {
      setFormValues({
        ...formValues,
        [name]: value
      });
    }
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setPreviewImage(reader.result);
      };
      reader.readAsDataURL(file);
      setFormValues({
        ...formValues,
        image: file,
      });
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      await ExpensesServices.updateExpenses(data.id, formValues);
      alert('Addons updated successfully');
      onSuccess();
      closeModal();
    } catch (error) {
      console.error('Failed to update addons', error);
      alert('Failed to update addons');
    }
  };


  return (
    <div className="modal fade edit-box show d-block" id="editModal" tabIndex={-1} aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Expenses Edit</h5>
            <button type="button" className="btn-close" data-bs-dismiss="modal" onClick={closeModal} aria-label="Close" />
          </div>
          <div className="modal-body">
            <div className="container-box px-5">
              <div className="container-box-inner table-reponsive-tabe">
                <div className="page-details">
                  <form onSubmit={handleSubmit}>
                    <div className='row'>
                      <div className='col-md-4'>
                        <div className="input-field">
                          <label>Expenses Name<span className="red">*</span></label>
                          <input
                            type="text"
                            name="expensesName"
                            value={formValues.expensesName}
                            onChange={handleInputChange}
                            className="form-control"
                            required
                            placeholder='Enter Expenses Name'
                          />
                        </div>
                      </div>

                      <div className='col-md-4'>
                        <div className="input-field">
                          <label>Amount<span className="red">*</span></label>
                          <input
                            type="number"
                            name="amount"
                            value={formValues.amount}
                            onChange={handleInputChange}
                            className="form-control"
                            required
                            placeholder='Enter Amount'
                          />
                        </div>
                      </div>

                      <div className='col-md-4'>
                        <div className="input-field">
                          <label>Date<span className="red">*</span></label>
                          <input
                            type="date"
                            name="date"
                            value={formValues.date}
                            onChange={handleInputChange}
                            className="form-control"
                            required
                          />
                        </div>
                      </div>

                      <div className='col-md-4'>
                        <div className="input-field">
                          <label>Serial Number<span className="red">*</span></label>
                          <input
                            type="text"
                            name="serialNumber"
                            value={formValues.serialNumber}
                            onChange={handleInputChange}
                            className="form-control"
                            required
                            placeholder='Enter Serial Number'
                          />
                        </div>
                      </div>

                      <div className='col-md-4'>
                        <div className="input-field">
                          <label>Slip Upload</label>
                          <input
                            type="file"
                            name="image"
                            className="form-control"
                            onChange={handleFileChange}
                            accept="image/*"
                          />
                          <p>
                            <span>Drop an image or Paste URL (Max 1,500 x 1,500 px),</span>
                            Supported formats: png, jpeg, jpg, webp
                          </p>
                        </div>
                      </div>

                      <div className='col-md-4'>
                        <div className="file-preview text-center">
                          <img
                            id="uploadFile"
                            src={previewImage}
                            alt="Uploaded Preview"
                            style={{ maxWidth: '200px', maxHeight: '200px' }}
                          />
                        </div>
                      </div>

                      <h3 className="mt-4">Payment Details</h3>

                     

                      {/* Offline Payment Fields */}
                      {formValues.paymentMethod === 'offline' && (
                        <div className='col-md-4'>
                          <div className="input-field">
                            <label>Cheque Number<span className="red">*</span></label>
                            <input
                              type="text"
                              name="chequeNumber"
                              value={formValues.chequeNumber}
                              onChange={handleInputChange}
                              className="form-control"
                              required={formValues.paymentMethod === 'offline'}
                              placeholder='Enter Cheque Number'
                            />
                          </div>
                        </div>
                      )}

                      {/* Online Payment Fields */}
                      {formValues.paymentMethod === 'online' && (
                        <>
                          <div className='col-md-4'>
                            <div className="input-field">
                              <label>Transaction ID<span className="red">*</span></label>
                              <input
                                type="text"
                                name="transactionId"
                                value={formValues.transactionId}
                                onChange={handleInputChange}
                                className="form-control"
                                required={formValues.paymentMethod === 'online'}
                                placeholder='Enter Transaction ID'
                              />
                            </div>
                          </div>
                          <div className='col-md-4'>
                            <div className="input-field">
                              <label>Bank Name</label>
                              <input
                                type="text"
                                name="bankName"
                                value={formValues.bankName}
                                onChange={handleInputChange}
                                className="form-control"
                                placeholder='Enter Bank Name'
                              />
                            </div>
                          </div>
                          <div className='col-md-4'>
                            <div className="input-field">
                              <label>Account Number</label>
                              <input
                                type="text"
                                name="accountNumber"
                                value={formValues.accountNumber}
                                onChange={handleInputChange}
                                className="form-control"
                                placeholder='Enter Account Number'
                              />
                            </div>
                          </div>
                          <div className='col-md-4'>
                            <div className="input-field">
                              <label>UPI ID</label>
                              <input
                                type="text"
                                name="upiId"
                                value={formValues.upiId}
                                onChange={handleInputChange}
                                className="form-control"
                                placeholder='Enter UPI ID'
                              />
                            </div>
                          </div>
                        </>
                      )}

                     
                      <div className='col-md-12 mt-3'>
                        <button className="submit-green-btn">Submit</button>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UpdateCoupan;
